const Rotaion = () => {
  return (
    <div className="bg-black h-screen text-center py-10">
      <img
        src={"https://cdn.firouzeh.com/public/rotation-pwa.gif"}
        alt="rotation"
        className="mx-auto"
      />
      <span className="display-medium text-white ">
        لطفا صفحه گوشی را بچرخانید
      </span>
    </div>
  );
};
export default Rotaion;
